import { useEffect, useState } from 'react'

export function usePresence(open, { duration = 200, reduced = false } = {}) {
  const [mounted, setMounted] = useState(() => !!open)
  const [leaving, setLeaving] = useState(false)

  useEffect(() => {
    if (open) {
      setMounted(true)
      setLeaving(false)
      return undefined
    }
    if (!mounted) return undefined
    if (reduced) {
      setMounted(false)
      setLeaving(false)
      return undefined
    }
    setLeaving(true)
    const timer = window.setTimeout(() => {
      setMounted(false)
      setLeaving(false)
    }, duration)
    return () => window.clearTimeout(timer)
  }, [open, duration, reduced, mounted])

  return { mounted, leaving }
}
